import * as React from 'react';
import classnames from 'classnames';

const Hr = ({ className  })=>/*#__PURE__*/ React.createElement("hr", {
        className: classnames('horizontal-rule', className)
    })
;
var Hr$1 = Hr;

export { Hr$1 as default };
//# sourceMappingURL=Hr.js.map
